import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
    static targets = ['lastspeaker'];

    updatePositon(date) {
        if (window.innerWidth >= 800) {
            const dateRect = date.getBoundingClientRect();
            const dateTop = dateRect.top + document.body.scrollTop;
            const dateBottom = dateTop + date.offsetHeight;
            const speakerRect = this.lastspeakerTarget.getBoundingClientRect();
            const speakerTop = speakerRect.top + document.body.scrollTop;
            const speakerBottom = speakerTop + this.lastspeakerTarget.offsetHeight;
        } else {
            date.style.removeProperty('transform');
        }

        window.requestAnimationFrame(() => { this.updatePositon(date) });
    }

    lastspeakerTargetConnected() {
        //window.requestAnimationFrame(() => { this.updatePositon(this.element) });
    }
}
